(function () {
  // above-water-product-detail1.liquid renders these as sibling sections, and
  // every one of them is driven by the product's metafields. Swapping only the
  // first left the marquee and media showing the previous product -- its
  // --aw-flavor-bg, badge, marquee text and graphic.
  const PANELS = ['.aw-product-detail', '.aw-flavor-marquee', '.aw-flavor-media'];

  // Guards against a slow response for an earlier click landing after a later
  // one and putting the wrong product on screen.
  let requestId = 0;

  function panels() {
    return PANELS.map((selector) => document.querySelector(selector)).filter(Boolean);
  }

  function fade(nodes, opacity) {
    nodes.forEach((node) => {
      node.style.transition = 'opacity 0.3s ease-in-out';
      node.style.opacity = opacity;
    });
  }

  // A direct link visit lets the browser's own preload scanner start fetching
  // the hero image before any JS runs, so it's usually warm in cache by the
  // time it's needed again. The fetch()+DOMParser swap above has no equivalent
  // -- the image request can't start until the whole HTML response has been
  // read and parsed. Warming the neighbours' images ourselves as soon as we
  // know their URLs (rendered into data-preload-* on the nav links) closes
  // that gap, so Next/Prev feels as cached as a real navigation.
  const preloaded = new Set();

  function preloadAdjacent() {
    document.querySelectorAll('.aw-product-detail__nav[data-preload-image], .aw-product-detail__nav[data-preload-sprite]').forEach((nav) => {
      ['preloadImage', 'preloadSprite'].forEach((key) => {
        const url = nav.dataset[key];
        if (!url || preloaded.has(url)) return;
        preloaded.add(url);
        const image = new Image();
        image.src = url;
      });
    });
  }

  async function navigate(url, { push }) {
    const current = panels();
    if (!current.length) return false;

    const token = ++requestId;
    fade(current, '0.5');

    let doc;
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    } catch (error) {
      console.error('AJAX navigation failed:', error);
      return false;
    }

    if (token !== requestId) return true; // a newer navigation already won

    // Nothing is swapped unless the whole set parsed, so a partial response can
    // never leave two products mixed on the page.
    const replacements = PANELS.map((selector) => ({
      selector,
      from: document.querySelector(selector),
      to: doc.querySelector(selector)
    })).filter((pair) => pair.from && pair.to);

    if (!replacements.length) return false;

    replacements.forEach((pair) => pair.from.replaceWith(pair.to));

    if (push) window.history.pushState(null, '', url);

    const added = panels();
    added.forEach((node) => {
      node.style.opacity = '0';
      node.style.transition = 'opacity 0.3s ease-in-out';
    });

    // Let the new markup paint before fading it back in.
    setTimeout(() => fade(added, '1'), 50);

    // The marquee (and anything else keyed to the product) re-initialises here.
    // The replaced nodes carry no data-initialized attribute, so their guards
    // pass, and the old marquee's rAF loop stops on its own once its node is
    // no longer in the document.
    document.dispatchEvent(new CustomEvent('aw:product:changed'));
    preloadAdjacent();
    return true;
  }

  function initAjaxNavigation() {
    preloadAdjacent();

    document.addEventListener('click', async function (e) {
      const navLink = e.target.closest('.aw-product-detail__nav');
      if (!navLink) return;

      e.preventDefault();
      const url = navLink.href;
      if (!(await navigate(url, { push: true }))) window.location.href = url;
    });

    window.addEventListener('popstate', async function () {
      if (!document.querySelector('.aw-product-detail')) return;
      if (!(await navigate(window.location.href, { push: false }))) window.location.reload();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAjaxNavigation);
  } else {
    initAjaxNavigation();
  }
})();
